'use client';

const Skeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={`animate-pulse rounded-lg bg-gray-300 ${className}`}
      {...props}
    />
  );
};

export default Skeleton;
